"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _InputLabel = _interopRequireDefault(require("../InputLabel"));
var _InputMessage = _interopRequireDefault(require("../InputMessage"));
var S = _interopRequireWildcard(require("./ToggleButtons.style"));
var _excluded = ["name", "label", "items", "defaultValue", "onChange"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var RoundedWarningIcon = function RoundedWarningIcon(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26 14c0 6.627-5.373 12-12 12S2 20.627 2 14 7.373 2 14 2s12 5.373 12 12zm-1.6 0c0-5.744-4.656-10.4-10.4-10.4C8.256 3.6 3.6 8.256 3.6 14c0 5.744 4.656 10.4 10.4 10.4 5.744 0 10.4-4.656 10.4-10.4zm-11.2 6.2v-1.4a.8.8 0 0 1 1.6 0v1.4a.8.8 0 0 1-1.6 0zm0-4V7.8a.8.8 0 0 1 1.6 0v8.4a.8.8 0 0 1-1.6 0z"
  }));
};
RoundedWarningIcon.defaultProps = {
  fill: "currentColor",
  width: "28",
  height: "28",
  viewBox: "0 0 28 28",
  xmlns: "http://www.w3.org/2000/svg"
};
var ToggleButtons = function ToggleButtons(_ref) {
  var name = _ref.name,
    label = _ref.label,
    items = _ref.items,
    defaultValue = _ref.defaultValue,
    _onChange = _ref.onChange,
    props = _objectWithoutProperties(_ref, _excluded);
  var error = props.error,
    errorMessage = props.errorMessage;
  return /*#__PURE__*/_react["default"].createElement(S.ToggleButtons, props, /*#__PURE__*/_react["default"].createElement(_InputLabel["default"], {
    color: error ? 'error' : 'text'
  }, label), /*#__PURE__*/_react["default"].createElement(S.ToggleButtonsList, {
    error: props.error
  }, items.map(function (button, index) {
    return /*#__PURE__*/_react["default"].createElement(S.ToggleButtonsItem, {
      key: index
    }, /*#__PURE__*/_react["default"].createElement(S.Input, {
      type: "radio",
      name: name,
      value: button.value,
      id: "".concat(name, "-").concat(index),
      defaultChecked: defaultValue === button.value,
      onChange: function onChange(event) {
        return _onChange({
          value: event.target.value
        });
      }
    }), /*#__PURE__*/_react["default"].createElement(S.ToggleButtonsItemLabel, {
      error: error,
      htmlFor: "".concat(name, "-").concat(index)
    }, button.label));
  })), error && /*#__PURE__*/_react["default"].createElement(_InputMessage["default"], {
    color: "error"
  }, /*#__PURE__*/_react["default"].createElement(RoundedWarningIcon, null), " ", errorMessage));
};
ToggleButtons.propTypes = {
  /**
   * The name of the field
   * */
  name: _propTypes["default"].string.isRequired,
  /**
   * The label's text for this field
   * */
  label: _propTypes["default"].string,
  /**
   * The value that matches one of the items in the `items` prop
   *  */
  defaultValue: _propTypes["default"].string,
  /**
   * The array containing the options for the toggleButtons
   * */
  items: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    label: _propTypes["default"].string,
    value: _propTypes["default"].string
  })),
  /**
   * If true, it will show the error layout and message
   * */
  error: _propTypes["default"].bool,
  /**
   * The error message
   * */
  errorMessage: _propTypes["default"].string,
  /**
   * Event called each time a new value is selected
   * */
  onChange: _propTypes["default"].func
};
ToggleButtons.defaultProps = {
  label: '',
  items: [],
  error: false,
  errorMessage: '',
  onChange: function onChange() {
    return undefined;
  }
};
var _default = exports["default"] = ToggleButtons;